// Texto por defecto de la home editable (specs/138-editor-contenido-paginas). Es la fuente del contenido
// mientras nadie lo edite en el panel; una edición guardada lo reemplaza por bloque.
import type { FaqContenido, TarjetaContenido } from "@/lib/page-content/tipos";

export interface ContenidoHome {
  /** Fecha (YYYY-MM-DD) del último cambio de contenido: `lastmod` de la home en el sitemap. */
  actualizado: string;
  /** Markdown: párrafo bajo el título principal de la portada. */
  intro: string;
  /** Exactamente 5 pasos (el diseño es de 5 columnas). */
  proceso: TarjetaContenido[];
  faqs: FaqContenido[];
}

export const contenido: ContenidoHome = {
  actualizado: "2026-10-05",
  intro:
    "Ejecutamos activaciones de marca, eventos corporativos, trade marketing, sampling e impulsación en Lima y todo el Perú — para que tu marca esté frente a su público sin que tú tengas que perseguir proveedores ni improvisar en el camino. Un solo equipo planifica, produce, supervisa y reporta. Propuesta a medida en menos de 72 horas.",
  proceso: [
    {
      title: "Brief",
      desc: "Conversamos contigo para entender el objetivo, el público, las fechas y el presupuesto disponible.",
    },
    {
      title: "Propuesta",
      desc: "Te enviamos concepto, plan de ejecución y presupuesto desglosado por línea — sin costos ocultos.",
    },
    {
      title: "Producción",
      desc: "Coordinamos proveedores, permisos, materiales gráficos y equipo de campo. Tú no persigues a nadie.",
    },
    {
      title: "Ejecución",
      desc: "Operamos la activación en sitio con supervisor presente, protocolo definido y comunicación en tiempo real.",
    },
    {
      title: "Reporte",
      desc: "Entregamos reporte con fotos, cobertura y métricas operativas. Evidencia real de lo ejecutado.",
    },
  ],
  faqs: [
    {
      q: "¿Qué campañas puede ejecutar Improve Yourself?",
      a: "Planificamos y ejecutamos activaciones de marca, eventos corporativos, sampling, impulsación, trade marketing y volanteo. Definimos contigo el formato, los puntos de campaña, el personal y la supervisión según el objetivo y las fechas del proyecto.",
    },
    {
      q: "¿En qué se diferencian las empresas BTL de una agencia de publicidad?",
      a: "Las empresas BTL como Improve Yourself se especializan en ejecución presencial: producen y operan activaciones, gestionan personal de campo y miden cobertura punto a punto. Una agencia de publicidad trabaja principalmente con medios y creatividad. El BTL complementa la publicidad cuando la marca necesita contacto físico con su público objetivo.",
    },
    {
      q: "¿Qué hace a Improve Yourself diferente de otras empresas BTL en Lima?",
      a: "Producimos eventos y activaciones en Lima desde 2018. Coordinamos en un solo equipo: la estrategia, la producción, el personal de campo y la supervisión en sitio. No tercerizamos la operación ni desconectamos el brief del reporte. El cliente habla con el mismo equipo desde la propuesta hasta el cierre. Propuesta a medida en menos de 72 horas.",
    },
    {
      q: "¿Qué incluye una activación BTL?",
      a: "Una activación BTL incluye el concepto creativo, el plan de ejecución, la producción de materiales y stand, el personal de campo (impulsadoras, promotoras o anfitrionas), la supervisión en sitio y el reporte final con fotos y cobertura. Cada propuesta se arma a medida según tu brief.",
    },
    {
      q: "¿Cuánto cuesta una activación BTL en Lima?",
      a: "El costo depende del alcance: cantidad de puntos, duración, personal y producción gráfica. No hay un precio fijo porque cada proyecto es distinto. Lo que sí garantizamos es un presupuesto desglosado por línea, sin costos ocultos, en menos de 72 horas hábiles desde que recibimos el brief.",
    },
    {
      q: "¿Qué tipos de eventos corporativos realizan?",
      a: "Producimos eventos corporativos en Lima: lanzamientos de marca, kick-offs comerciales, convenciones, aniversarios de empresa, reuniones internas y eventos de prensa. Coordinamos venue, producción audiovisual, branding y personal de apoyo.",
    },
    {
      q: "¿Brindan impulsadoras y promotoras para campañas?",
      a: "Sí. Brindamos impulsadoras, promotoras, anfitrionas y personal de apoyo para activaciones BTL, eventos corporativos y campañas de impulsación en punto de venta. Seleccionamos por perfil, capacitamos en producto y supervisamos en sitio.",
    },
    {
      q: "¿Qué incluye el servicio de trade marketing?",
      a: "El servicio de trade marketing incluye implementación de material POP, exhibiciones especiales en góndola, mecánicas promocionales, personal de impulso y reporte fotográfico por punto de venta. Trabajamos canal moderno y canal tradicional.",
    },
    {
      q: "¿Trabajan solo en Lima o también en provincias?",
      a: "Operamos directamente en Lima Metropolitana y Callao, con rutas de volanteo planificadas por distrito, zona o radio alrededor de un local. Para campañas en provincias, coordinamos producción y logística según el alcance y las fechas del proyecto.",
    },
  ],
};
